import React, { useEffect, useState } from 'react';
import { IonList, IonItem, IonLabel, IonItemGroup, IonIcon, IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonItemDivider, IonText, IonButtons, IonBackButton, IonImg, IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, useIonAlert } from '@ionic/react';
import { chevronDownOutline, chevronUpOutline, downloadOutline, home, homeOutline, image, imageOutline } from 'ionicons/icons';
import { _ANY_ACTIVITY_PREFIX, _TEMPLATE_A_ACTIVITIES_NR, _defaultButtonColor, _dict, _libName, _pathSeparator, _rootName } from './constants';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useTreeStore } from './stateManagement/treeZustand';
import { useURLStore } from './stateManagement/URLZustand';
import { useHistory } from 'react-router';
import { downloadDemoTemplateA, downloadFullTemplateA } from '../foo/downloader';
import { useUserStore } from './stateManagement/userZustand';
import { logMe } from '../foo/user';
import { goToPayment } from './payments';




const Activities: React.FC = () => {
  const [ expandedItem, setExpandedItem] = useState<string | null>("A");
  const { lang } = useGlobalStore();
  const { nodes, l2Image, importPecs} = useTreeStore();
  const { getURLTo } = useURLStore();
  const { isSubscribed, userUniqueId} = useUserStore();
  const [ activityListJSX, setActivityListJSX ] = useState<JSX.Element[]>([]);
  const [ downloadToggle, setDownloadToggle ] = useState<boolean>(false);
  const history = useHistory();
  const [ presentAlert ] = useIonAlert();

  const FreeQuotaAlert = () => presentAlert({
    header: _dict.premiumFeature[lang],
    message: _dict.premiumFeatureDescription[lang],
    buttons: [{
      text: _dict.freeQuotaPremiumBtnText[lang],
      handler: async () => { logMe("click_premium",{from:"freeQuotaAlertInActivities"}); goToPayment(userUniqueId) }
    }]
  });

  const handleClick = (itemTitle: string) => {
    setExpandedItem(itemTitle === expandedItem ? null : itemTitle);
  };

  useEffect(() => {
    if(expandedItem === null){return;}
    else if(expandedItem === "A"){
        const imagesKeys = nodes[getURLTo().templateA()]?.filter(node => node.startsWith(_ANY_ACTIVITY_PREFIX)) || [];

        setActivityListJSX(imagesKeys.map((key) => {
            return (
            <IonCard key={key} style={{ flex: 1 }} onClick={() => {history.push(getURLTo().activity(expandedItem, key))}}>
            <IonCardContent>
                <IonImg src={l2Image[key]} style={{width: "100%"}} />
            </IonCardContent>

        </IonCard>);
        }));
    }
  }, [expandedItem, downloadToggle]);
  
  return (
    <IonPage>
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="start">
                    <IonBackButton defaultHref={getURLTo().home()}></IonBackButton>
                    <IonButton onClick={() => {history.push(getURLTo().home())}}>
                        <IonIcon slot="icon-only" icon={home} />
                    </IonButton>
                </IonButtons>
                <IonTitle>{_dict.activities[lang]}</IonTitle>
            </IonToolbar>
        </IonHeader>
        <IonContent>
            
            <IonList>
                <IonItemGroup>
                    <IonItem button onClick={() => handleClick("A")} lines='none' color={expandedItem === "A" ? "light" : ""}>
                        <IonLabel>{_dict.visualComprehensionTask[lang]}</IonLabel>
                        <IonIcon slot="start" icon={expandedItem === "A" ? chevronUpOutline : chevronDownOutline} />
                    </IonItem>
                    {expandedItem === "A" && (
                        <>
                            <IonItemDivider color="light">
                                <IonText color="dark">
                                    <strong>{_dict.taskDescription[lang]}</strong>
                                </IonText>
                            </IonItemDivider>
                            <IonItem lines="none">
                                <IonText color="dark">{_dict.visualComprehensionTaskInstructions[lang]}</IonText>
                            </IonItem>
                            <IonItemDivider color="light">
                                <IonText color="dark">
                                    <strong>{_dict.selectActivity[lang]}</strong>
                                </IonText>
                            </IonItemDivider>
                            <IonItem lines="none">
                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                                    {activityListJSX}
                                    {activityListJSX?.length === 0 ? <IonCard style={{ flex: 1, display: 'flex',  justifyContent: 'center', alignItems: 'center' }}
                                        onClick={() => {
                                            downloadDemoTemplateA().then((pecs:any) => {
                                                importPecs(pecs, _rootName+_pathSeparator+_libName);
                                                setDownloadToggle(!downloadToggle);
                                            });
                                        }}>
                                        <IonCardContent>
                                            <div style={{textAlign:"center"}}>
                                                <IonIcon icon={downloadOutline} size="large" />
                                            </div>
                                            {_dict.experienceAnActivity[lang]}
                                        </IonCardContent>
                                    </IonCard> :
                                    activityListJSX?.length < _TEMPLATE_A_ACTIVITIES_NR ?
                                    <IonCard style={{ display: 'flex', flexDirection: 'column', textAlign:"center" }}>
                                        <IonCardHeader>
                                            <IonCardTitle>{_dict.downloadActivities[lang]}</IonCardTitle>
                                        </IonCardHeader>

                                        <IonCardContent style={{ display: 'flex', flex:"1", height:"100%", flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <div>{_dict.downloadOtherAvailableActivities[lang]}</div>
                                        <div ><IonButton shape="round" expand="full" style={{"--background": _defaultButtonColor, minHeight:"40px"}}
                                        onClick={() => {
                                            if(isSubscribed){
                                                downloadFullTemplateA().then((pecs:any) => {
                                                    importPecs(pecs, _rootName);
                                                    setDownloadToggle(!downloadToggle);
                                                });
                                            }else{
                                                FreeQuotaAlert();
                                            }
                                            
                                        }}>
                                            <IonIcon slot="start" icon={downloadOutline} />
                                            {_dict.download[lang]}
                                        </IonButton></div>
                                        </IonCardContent>
                                    </IonCard>
                                    : null
                                    }
                                
                                   
                                </div>
                            </IonItem>
                        </>
                    )}
                </IonItemGroup>
            </IonList>
        </IonContent>
    </IonPage>


  );
};

export default Activities;
